<div class="w-full p-4 flex align-items-center justify-content-center">
    <div class="w-full max-w-30rem flex flex-column gap-2 bg-white border-1 border-round-2xl p-5" style="border-color: #d0d0dd; color: #000086;">
        <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/images/calendarly-logo.jpg" alt="" class="w-full block max-w-16rem">
        </div>
        <div class="w-full flex align-items-center justify-content-center">
          <p-button label="Integrate" styleClass="integrate" (onClick)="integrateCalendly()"  />
        </div>
    </div>
</div>
